<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct"><a href="#/DemonataHellsH_toc#chap-2">CLOCKING OFF</a></h1>
<p class="img"><img alt="art" src="images/Art_Ptagger.jpg"/></p>
<p class="cotx"><span class="dropcap"><strong>C</strong></span><strong>REEPING</strong> through a factory, in pursuit of a snake demon twenty-five feet long. I wouldn’t have thought a beast that size could hide
         easily, but I’ve been searching for several minutes without success. I should be out on the streets, battling the masses,
         but this demon killed a Disciple. She was an elderly, frail lady, but she could swing a spike-headed mace more effectively
         than anyone I’ve ever met. I never asked her name, but I liked her. I’m going to make her killer pay.
      </p>
<p>I slide around a corner, checking the pipes overhead. I feel edgy, which is odd. I haven’t felt anything but cold, detached
         hatred recently. I guess the tension of the moment has got to me. I’m sure the demon won’t prove to be a serious threat—I’m
         more than a match for any of the familiars who cross through windows—but it’s fun to pretend I’m in danger. I’d almost forgotten
         what fear was like.
      </p>
<p>A scraping noise behind me. I whirl, a ball of magical energy crackling at my fingertips. But it’s only Moe. He <a id="page-8">followed me
         into the building, even though I told him to stay outside. Moe’s one of three werewolves who’ve been with me since Wolf Island.
         Werewolves don’t need names, but after a few weeks with the trio, I felt like I should call them something. So I christened
         them Curly, Larry, and Moe, after the Three Stooges. I never had much time for the Stooges, but Dervish loved them, so I named
         the werewolves in his memory.
      </a></p><a id="page-8">
<p>I growl at Moe to let him know I’m displeased. He makes a soft whining noise, but he can tell I’m not that bothered. Moe takes
         his bodyguard duties seriously. He never likes to be too far from me. I think he feels a bit lost when I’m not there for him
         to protect.
      </p>
<p>Letting Moe fall into place behind me, I push farther into the factory, past a long conveyor belt. Workers were sitting in
         the chairs alongside it just an hour ago. It’s been nearly a month since Dervish died in the desert. There have been dozens
         of crossings since then. Hundreds of thousands of humans have been killed. People are terrified and desperate, but life goes
         on. A few of us know the cause is hopeless, but we haven’t shared the bad news. As far as the general population is concerned,
         we can beat these demonic invaders. So, as the body count mounts, folk carry on normally, manning their posts even in the
         face of an impending crossing, slipping away to safety at the last moment, returning as soon as the window closes.
      </p>
<p>Moe growls and darts to a nearby locker. I start to follow, assuming it’s the demon, but when he rips the locker door off
         and tears open a lunchbox, I realize he’s found a sandwich.
      </p>
</a><p><a id="page-8"></a><a id="page-9">“Idiot,” I grunt, turning back to the conveyor belt.</a></p><a id="page-9">
<p>Fangs sink into my thigh. Yelling, I fall and the snake drags me into the gloom beneath the belt, where it’s been lying in
         wait. I strike at its eyes, but it doesn’t have any. Gripping me tightly, it drives its fangs farther into my flesh, crushing
         the bones in my leg.
      </p>
<p>I once read a survival pamphlet that said if a giant snake ever got hold of you, you should lie still, so it thinks you are
         dead. Then, as it swallows your legs, you free your knife (too bad if you don’t have one) and hold it by your side. As the
         snake devours your thighs and sets to work on your stomach, you drive the tip of the knife up through the roof of its mouth
         and deep into its brain. That always grossed out girls when I told them!
      </p>
<p>I’m sure it’s sound advice, but I don’t have time to test it. Unlike most large snakes, this demon’s poisonous and I can feel
         its venom coursing through my veins. I don’t have the luxury of playing possum. Besides, that’s not my style.
      </p>
<p>Grunting against the pain, I grab the demon’s fangs and snap them off. The beast chokes and releases me, spewing poisonous
         pink blood. I drive one of the broken fangs into the side of its head. It squeals like a baby and thrashes across the floor.
         I hang on, riding it bronco-style, stabbing at it again and again. More blood froths from the wounds, soaking my face and
         chest.
      </p>
</a><p><a id="page-9">As the snake slams against the conveyor belt, knocking it over, I thrust my head in its mouth and roar down its throat. A
         ball of magic bursts from my lips and rips through the demon’s body. It explodes into tattered, slimy shreds. I pick some
         of the foul scraps from between my teeth, then focus </a><a id="page-10">magic into my leg and repair the damage. Getting to my feet, I look for
         Moe. He’s still munching the sandwich.
      </a></p><a id="page-10">
<p>“Great help you were,” I snarl, using more magic to clear my veins of poison.</p>
<p>Moe looks at me guiltily, then holds out the last piece of sandwich. I turn my nose up at it and hobble for the doorway, eager
         to squeeze in more killing before the window between universes shuts and robs me of my demonic punching bags.
      </p>
<p class="spb"><img alt="art" src="images/Art_Pstagger.jpg"/> The streets are awash with demons, the usual assortment of vile concoctions, many cobbled together from bodies resembling
         those of animals, fish, and birds. Demons are an unimaginative lot. Most can use magic to mold their forms, but rather than
         give themselves original, amazing bodies, they copy ours.
      </p>
<p>Dozens of werewolves are fighting the demons. I had them imported from Wolf Island, to replace those of my original pack.
         Most of the new specimens aren’t as sturdy, fast, or smart as those I first chose, but they get the job done. Curly’s in the
         middle of them, acting as pack leader in my absence. She’s a fierce creature, taller than me, though not as broad. Sharp too.
         She can always spot if one of the werewolves disobeys orders and attacks a human instead of a demon. She pounces on the offending
         party in an instant and slits the beast’s throat without blinking. No second chances with Curly.
      </p>
</a><p><a id="page-10">Soldiers and freshly blooded mages support the werewolves. The soldiers don’t do much damage—you can only kill a demon with
         magic—but the mages are doing a pretty </a><a id="page-11">good job. They’re learning quickly. Not up to the level of the Disciples, but getting
         there fast.
      </a></p><a id="page-11">
<p>I move among the apprentices, taking the place of the mace-wielding old lady. There aren’t many Disciples left, so they’re
         spread thinly across the world, one or two per group of mages. I see the men and women around me flinch as I pass. They know
         who I am. They’ve seen me kill more demons than anybody else. They know they’re safe when I’m around. But I’m a fearsome sight,
         and most find it hard to suppress a shudder when they find themselves beside me.
      </p>
<p>I could change back if I wished, resume my human form. But I prefer it this way. It’s easier to lead people to their death
         if you’re not truly one of them.
      </p>
<p>A girl, no more than twelve or thirteen, is playing with a wooden yo-yo. As a demon comes within range, she snaps the yo-yo
         at it. The wood splinters and the shards puncture the demon’s eyes. She replaces it with another yo-yo, this time a plastic
         one.
      </p>
<p>“Nice work,” I grunt.</p>
<p>She looks up at me and fakes a yawn. “Whatever.”</p>
<p>Magic isn’t a natural part of our universe. But some humans—mages—are born with the ability to tap into it. When a demon opens
         a window from its universe to ours, magical energy spills through. If you’re a mage, you’re in business.
      </p>
</a><p><a id="page-11">In the past, very few mages got to unleash their power. Windows weren’t opened often. It was hard for the Disciples to find
         new recruits. Now that demons have gone into overdrive, and two or three windows open every day, it’s simple. </a><a id="page-12">When a window
         is forming, we arrange for crowds of people to wait close by, then test them for magical prowess. Those who show promise are
         thrown into the fray after a quick burst of training, to perish or triumph.
      </a></p><a id="page-12">
<p>I see a window in the near distance. A child, even younger than the girl with the yo-yo, stands to one side. A man and woman
         are behind her. I guess they’re using the girl. She probably had no choice in this. But, innocent or not, the Demonata are
         working through her, so she has to die.
      </p>
<p>As I push through the battling demons, werewolves, and humans, I marvel at the greed of mankind. I should be accustomed to
         it, but I’m still astonished every time it happens. Most mages use their powers for good, especially now that people can clearly
         see the full, destructive evil of the Demonata.
      </p>
<p>But there are others who side with the demons. They seek power, wealth, a longer life. They scent an opportunity to get ahead
         and sell off their souls to the highest bidder without a second thought. It never seems to occur to them that there will be
         no place in a demon-run world for <em>any</em> humans, even the most evil. Demons don’t do coalitions.
      </p>
<p>The woman behind the girl spots me. She taps the girl’s shoulder and mutters in her ear. The three of them edge closer to
         the window. Uh-uh! Can’t have them slipping away early. That wouldn’t be fair. I bark a phrase of magic and erect an invisible
         barrier between the trio and the window. Panic shoots across the faces of the adults. The girl simply looks confused.
      </p>
</a><p><a id="page-12">The man hurls himself at the barrier, trying to smash it with his shoulder. The woman curses and draws a gun. As </a><a id="page-13">she trains
         it on me, I turn it into a posy of flowers. She stares at the petals, sadness filling her eyes as she realizes this will serve
         as her death wreath. Then Moe barrels onto the scene and knocks her to the ground. Her screams excite the wolf in me and I
         fall on the man, snarling. He just has time to beg for mercy. Then my teeth are around his throat and the sweet taste of human
         flesh fills my mouth.
      </a></p><a id="page-13">
<p>I gulp the man’s blood, then toss his carcass aside and loom over the girl. She gazes up at me, that confused look still crinkling
         her features. She’s even younger than I thought, maybe seven or eight. She’s clutching a small teddy bear in one hand.
      </p>
<p>“Are you the boogey man?” she whispers, eyes round.</p>
<p>“Yes,” I croak, then take hold of her head with my huge, scarred, blood-soaked hands and crush.</p>
<p>Thoughts of Juni Swan flicker through my mind as the girl shakes and drops the teddy bear. Juni was Lord Loss’s assistant.
         She could catch glimpses of the future. We fought on Wolf Island. She had me beaten, but then let me go. Because, in a vision,
         she saw me destroying the world.
      </p>
<p>I’ve tried to dismiss Juni’s prophecy, but I’m sure it’s true. I often think that I should throw myself off a cliff or let
         the demons kill me. The world would be a safer place without me. But I can’t do it. Life’s too sweet. So I lie to myself and
         cling to false hope that she was wrong, even though I know it’s selfish madness.
      </p>
<p>As the girl goes still, I set her down and wonder if I’ll crush the world as easily as her head.</p>
</a><p><a id="page-13">The window flashes out of existence, stranding the demons. With screams of despair, they battle furiously, </a><a id="page-14">eager to kill as
         many humans as they can before this universe rids itself of their ugly stain. But they’re already weakening, robbed of the
         magic they need to survive.
      </a></p><a id="page-14">
<p>I feel my strength fading too. I’m a magician, so I can operate in the absence of a window. But I’m nowhere near as powerful
         as I am when the air’s thick with the delirious energy of the Demonata.
      </p>
<p>It doesn’t matter. I’m not essential in this final stage. Nor are the mages. This is where the werewolves and soldiers come
         into their own. They rip apart the weakened demons with fangs, claws, bullets, and machetes. The demons don’t die, but they
         no longer have the power to put themselves back together, so they can only lie there in pieces and wait to dissolve as magic
         drains from the air.
      </p>
<p>Moe cocks a deformed eyebrow at me and grunts questioningly.</p>
<p>“Go on,” I sigh, wincing at the pain in my leg. That’s the downside of using magic to heal a wound. It’s fine while there’s
         magical energy in the air, but once that passes, pain kicks in with a vengeance.
      </p>
<p>As Moe joins the bloodletting, a pale, thin, icy-looking woman approaches me. It’s Prae Athim, head of the Lambs, a group
         that once acted as executioners of Grady children who’d turned into werewolves. Now they supply me with fresh recruits from
         Wolf Island.
      </p>
<p>“That looks nasty,” Prae says, nodding at my leg. It’s purple, and pus seeps from the cuts that have reopened.</p>
<p>“I’ll be fine,” I mutter. “I got rid of all the poison before the window closed.”</p>
<p>“Does it hurt?” she asks.</p>
</a><p><a id="page-14"></a><a id="page-15">“Yes. But it won’t kill me.”</a></p><a id="page-15">
<p>“Still, you should have it looked at.”</p>
<p>I grin. Prae loves to mother her wolfen wards, even a semi-werewolf like me. She’s cold with humans but has a soft spot for
         those who’ve turned into savage, mindless killing machines.
      </p>
<p>“Will you look after the others?” I ask.</p>
<p>“Of course,” she snaps. “Don’t I always?”</p>
<p>Prae can’t directly control the werewolves—only I can do that—but she’s had years of experience and commands a team of specialists.
         When I’m tired or don’t have the time to round up the pack and settle them down, she moves in with her troops. They use electric
         prods, nets, and shackles where necessary, though having feasted on so many demons, most of the werewolves are happy to do
         as ordered.
      </p>
<p>“Will I see you later?” I ask. After a battle, Prae often spends the night with me, looking ahead to the next assault, discussing
         tactics.
      </p>
<p>“No,” she says. “We’re accepting a new shipment from the island. I want to make sure the transfer goes smoothly and get them
         quartered close to the others.”
      </p>
<p>“Do you want my help?”</p>
<p>She shakes her head. “I’ll make them comfortable first. You can give them your pep talk in the morning. I’m sure they’ll be
         impressed.”
      </p>
<p>Prae leaves and I chuckle softly. I’ve grown fond of her in recent weeks. She reminds me of Dervish. He could be a distant
         customer too, when he needed to be.
      </p>
</a><p><a id="page-15">Thinking of my dead uncle wipes the smile from my lips. I spend a few minutes remembering some of his finer </a><a id="page-16">moments—when he
         came to see me in the asylum after my family was killed, fighting Vein and Artery in the cellar at Carcery Vale, battling
         Lord Loss in the town of Slawter, dying with dignity in the desert.
      </a></p><a id="page-16">
<p>Then I recall his love for Juni, when we thought she was on our side, and that reminds me of her dire prophecy. Sighing miserably,
         I shuffle off to the hospital, wishing I could avoid quiet, human moments like these. Life’s a lot easier when chaos is erupting
         all around and the beastly wolf within me rises to the fore.
      </p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DemonataHellsH_chap-2.vue?2332ee5c